import { NO_ERRORS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OverlayModule } from '@angular/cdk/overlay';
import { SupplementalInfoComponent } from './components/supplemental-info/supplemental-info.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppNgMaterialModule } from '../app-ng-material.module';
import { AppNgAppkitModule } from '../app-ng-appkit.module';
import { AddSchdmTemplateIdComponent } from './components/add-schdm-template-id/add-schdm-template-id.component';
import { SourcingDefaultMeComponent } from './components/sourcing-default-me/sourcing-default-me.component';
import { SpotratesAllCurrSyncComponent } from './components/spotrates-all-curr-sync/spotrates-all-curr-sync.component';
import { FxAmtSyncComponent } from './components/fx-amt-sync/fx-amt-sync.component';
import { BatchSourcingDefaultComponent } from './components/batch-sourcing-default/batch-sourcing-default.component';
import { TestedUnitsSyncComponent } from './components/tested-units-sync/tested-units-sync.component';
import { FxRatesSyncComponent } from './components/fx-rates-sync/fx-rates-sync.component';
import { SourcingProjectTaggingComponent } from './components/sourcing-project-tagging/sourcing-project-tagging.component';
import { DomesticProjectTaggingComponent } from './components/domestic-project-tagging/domestic-project-tagging.component';
import { GhostUpdateCombinationComponent } from './components/ghost-update-combination/ghost-update-combination.component';
import { FgnF5471H1Component } from './components/fgn-f5471-h1/fgn-f5471-h1.component';
import { FgnOverrides163jComponent } from './components/fgn-overrides163j/fgn-overrides163j.component';
import { SettlementRedirectionComponent } from './components/settlement-redirection/settlement-redirection.component';
import { FirFormRegenComponent } from './components/fir-form-regen/fir-form-regen.component';
import { FirGhostOwnershipComponent } from './components/fir-ghost-ownership/fir-ghost-ownership.component';
import { FirGhostSourcingComponent } from './components/fir-ghost-sourcing/fir-ghost-sourcing.component';
import { FirQbuSourcingDeleteRecordComponent } from './components/fir-qbu-sourcing-delete-record/fir-qbu-sourcing-delete-record.component';
import { Fir163jTaggingComponent } from './components/fir-163j-tagging/fir-163j-tagging.component';
import { Fir163jDefaultSystemTaggingComponent } from './components/fir-163j-tagging/fir-163j-default-system-tagging/fir-163j-default-system-tagging.component';
import { Fir163jResetDefaultTaggingComponent } from './components/fir-163j-tagging/fir-163j-reset-default-tagging/fir-163j-reset-default-tagging.component';
import { Fir163jSyncTo8990Component } from './components/fir-163j-tagging/fir-163j-sync-to-8990/fir-163j-sync-to-8990.component';
import { Fir5471ScheduleMComponent } from './components/fir-5471-schedule-m/fir-5471-schedule-m.component';
import { Fir5471ScheduleIComponent } from './components/fir-5471-schedule-i/fir-5471-schedule-i.component';
import { Fir163jsyncComponent } from './components/fir163jsync/fir163jsync.component';
import { SharedComponentsModule } from '../shared/components/shared-components.module';
import { SharedDirectivesModule } from '../shared/_directives/shared-directives.module';
import { GtwSearchableSelectModule } from '../shared/_directives/gtw-searchable-select/gtw-searchable-select.module';
import { SharedPipesModule } from '../shared/pipes/shared-pipe.module';
import { Fir5471ScheduleOComponent } from './components/fir-5471-schedule-o/fir-5471-schedule-o.component';
import { Fir8858ScheduleMComponent } from './components/fir-8858-schedule-m/fir-8858-schedule-m.component';
import { CfcGroupElectComponent } from './components/cfc-group-elect/cfc-group-elect.component';
import { FirEpBumpComponent } from './components/fir-ep-bump/fir-ep-bump.component';
import { GhostOwnershipInfoDeleteComponent } from './components/ghost-ownership-info-delete/ghost-ownership-info-delete.component';
import { GhostcNonghostDeleteComponent } from './components/ghostc-nonghost-delete/ghostc-nonghost-delete.component';
import { GhostSettlementReclassesDeleteComponent } from './components/ghost-settlement-reclasses-delete/ghost-settlement-reclasses-delete.component';
import { GhostUsdbasisptiNonghostDeleteComponent } from './components/ghost-usdbasispti-nonghost-delete/ghost-usdbasispti-nonghost-delete.component';
import { GhostFtceNonghostDeleteComponent } from './components/ghost-ftce-nonghost-delete/ghost-ftce-nonghost-delete.component';
import { GhostEarnprofitNonghostDeleteComponent } from './components/ghost-earnprofit-nonghost-delete/ghost-earnprofit-nonghost-delete.component';
import { BasketMaintenanceDeleteComponent } from './components/basket-maintenance-delete/basket-maintenance-delete.component';
import { FirAdjustPriorYearDataComponent } from './components/fir-adjust-prior-year-data/fir-adjust-prior-year-data.component';
import { DcsGhostSettlementComponent } from './components/dcs-ghost-settlement/dcs-ghost-settlement.component';
import { Fir8865ScheduleOComponent } from './components/fir-8865-schedule-o/fir-8865-schedule-o.component';
import { CalcsScenarioDataSetupComponent } from './components/calcs-scenario-data-setup/calcs-scenario-data-setup.component';
import { CalcsFilingGroupStatusComponent } from './components/calcs-filing-group-status/calcs-filing-group-status.component';
import { FirTrueupTaxesComponent } from './components/fir-trueup-taxes/fir-trueup-taxes.component';
import { Trueup905cCommentsComponent } from './components/fir-trueup-taxes/trueup905Ccomments/trueup905ccomments.component';
import { LocalSysChartAcctMapDeleteComponent } from './components/local-sys-chart-acct-map-delete/local-sys-chart-acct-map-delete.component';
import { LocalSysChartAcctMapComponent } from './components/local-sys-chart-acct-map/local-sys-chart-acct-map.component';
import { FirLocalAcctDescComponent } from './components/fir-local-acct-desc/fir-local-acct-desc.component';
import { FirLocalSysChartAcctMapComponent } from './components/fir-local-sys-chart-acct-map/fir-local-sys-chart-acct-map.component';
import { Fir8865SchedulePComponent } from './components/fir-8865-schedule-p/fir-8865-schedule-p.component';
import { Form8865TextualComponent } from './components/form8865-textual/form8865-textual.component';
import { Fir5471ScheduleG1Component } from './components/fir-5471-schedule-g1/fir-5471-schedule-g1.component';
import { FirRepointComponent } from './components/fir-repoint/fir-repoint.component';
import { F8865SchdK1Component } from './components/f8865-schd-k1/f8865-schd-k1.component';
import { MaxLoanDeleteComponent } from './components/max-loan-delete/max-loan-delete.component';
import { MaxLoanBalHoComponent } from './components/max-loan-bal-ho/max-loan-bal-ho.component';
import { TaxLiabilityDashboardComponent } from './components/tax-liability-dashboard/tax-liability-dashboard.component';
import { SourcingInputAppBasketComponent } from './components/sourcing-input-app-basket/sourcing-input-app-basket.component';
import { ConsolGroupEditComponent } from './components/consol-group-edit/consol-group-edit.component';
import { Form8858TextualinfoComponent } from './components/form-8858-textualinfo/form-8858-textualinfo.component';
import { NonFinancialDirectOwnerComponent } from './components/non-financial-information/non-financial-direct-owner/non-financial-direct-owner.component';
import { NonFinancialTaxOwnerComponent } from './components/non-financial-information/non-financial-tax-owner/non-financial-tax-owner.component';
import { RetainedEarningsComponent } from './components/retained-earnings/retained-earnings.component';
import { AllLocalChartAdjustmentsComponent } from './components/all-local-chart-adjustments/all-local-chart-adjustments.component';
import { ReclassLocalChartComponent } from './components/reclass-local-chart/reclass-local-chart.component';
import { EpAdjsLocalChartComponent } from './components/ep-adjs-local-chart/ep-adjs-local-chart.component';
import { ElimReclassLocalComponent } from './components/elim-reclass-local/elim-reclass-local.component';
import { Fir5471ScheduleFComponent } from './components/fir-5471-schedule-f/fir-5471-schedule-f.component';
import { Fir5471ScheduleEComponent } from './components/fir-5471-schedule-e/fir-5471-schedule-e.component';
import { Fir5471ScheduleJComponent } from './components/fir-5471-schedule-j/fir-5471-schedule-j.component';
import { FirSysFormChartAcctMapComponent } from './components/fir-sys-form-chart-acct-map/fir-sys-form-chart-acct-map.component';
import { FirSanctionedCountriesComponent } from './components/fir-sanctioned-countries/fir-sanctioned-countries.component';
import { Form5471TextinfoComponent } from './components/form5471-textinfo/form5471-textinfo.component';
import { Form5471ScheduleGComponent } from './components/form5471-schedule-g/form5471-schedule-g.component';
import { Form5471ScheduleIComponent } from './components/form5471-schedule-i/form5471-schedule-i.component';
import { Fir8990ScheduleBComponent } from './components/fir-8990-schedule-b/fir-8990-schedule-b.component';
import { FirDividendsPaymentComponent } from './components/fir-dividends-payment/fir-dividends-payment.component';
import { FirMainTrialBalComponent } from './components/fir-main-trial-bal/fir-main-trial-bal.component';
import { FirReviewBookToEpComponent } from './components/fir-review-book-to-ep/fir-review-book-to-ep.component';
import { FirGiltiCalcGridComponent } from './components/fir-gilti-calc-grid/fir-gilti-calc-grid.component';
import { FirGiltiConsolidatedGridComponent } from './components/fir-gilti-consolidated-grid/fir-gilti-consolidated-grid.component';
import { FirSubmitterDiagnosticsComponent } from './components/fir-submitter-diagnostics/fir-submitter-diagnostics.component';
import { FirDiagnosticCenterComponent } from './components/fir-diagnostic-center/fir-diagnostic-center.component';
import { FirConsolidationTbComponent } from './components/fir-consolidation-tb/fir-consolidation-tb.component';
import { DataProduce5471Component } from './components/data-produce-5471/data-produce-5471.component';
import { DataProduce8858Component } from './components/data-produce-8858/data-produce-8858.component';
import {} from '@angular/common/http';
import { FirEpDrilldownComponent } from './components/fir-ep-drilldown/fir-ep-drilldown.component';
import { FirAnalyzeCurrentTaxesComponent } from './components/fir-analyze-current-taxes/fir-analyze-current-taxes.component';
import { MaxLoanBalanceComponent } from './components/max-loan-balance/max-loan-balance.component';
import { FirPost86TaxHistoryComponent } from './components/fir-post86-tax-history/fir-post86-tax-history.component';
import { FirPtiSummaryReportComponent } from './components/fir-pti-summary-report/fir-pti-summary-report.component';
import { FirBasketMaintenanceComponent } from './components/fir-basket-maintenance/fir-basket-maintenance.component';
import { FirCfcsWithQualDefComponent } from './components/fir-cfcs-with-qual-def/fir-cfcs-with-qual-def.component';
import { FirCfcsWithRecapAcctComponent } from './components/fir-cfcs-with-recap-acct/fir-cfcs-with-recap-acct.component';
import { FirHoveringDeficitComponent } from './components/fir-hovering-deficit/fir-hovering-deficit.component';
import { FirGtapsCommonTemplateComponent } from './components/fir-gtaps-common-template/fir-gtaps-common-template.component';
import { FirPost86EpHistoryComponent } from './components/fir-post86-ep-history/fir-post86-ep-history.component';
import { ProjectTaggingComponent } from './components/project-tagging/project-tagging.component';
import { ProjectTagComponent } from './components/project-tag/project-tag.component';

@NgModule({
  declarations: [
    SupplementalInfoComponent,
    SourcingDefaultMeComponent,
    SpotratesAllCurrSyncComponent,
    FxAmtSyncComponent,
    BatchSourcingDefaultComponent,
    TestedUnitsSyncComponent,
    FxRatesSyncComponent,
    SourcingProjectTaggingComponent,
    DomesticProjectTaggingComponent,
    GhostUpdateCombinationComponent,
    FgnF5471H1Component,
    FgnOverrides163jComponent,
    SettlementRedirectionComponent,
    FirFormRegenComponent,
    FirGhostOwnershipComponent,
    FirGhostSourcingComponent,
    FirQbuSourcingDeleteRecordComponent,
    Fir163jTaggingComponent,
    Fir163jDefaultSystemTaggingComponent,
    Fir163jResetDefaultTaggingComponent,
    Fir163jSyncTo8990Component,
    Fir5471ScheduleMComponent,
    Fir5471ScheduleIComponent,
    Fir163jsyncComponent,
    Fir5471ScheduleOComponent,
    CfcGroupElectComponent,
    FirEpBumpComponent,
    Fir8858ScheduleMComponent,
    GhostOwnershipInfoDeleteComponent,
    GhostcNonghostDeleteComponent,
    GhostSettlementReclassesDeleteComponent,
    GhostUsdbasisptiNonghostDeleteComponent,
    GhostFtceNonghostDeleteComponent,
    GhostEarnprofitNonghostDeleteComponent,
    BasketMaintenanceDeleteComponent,
    FirAdjustPriorYearDataComponent,
    DcsGhostSettlementComponent,
    Fir8865ScheduleOComponent,
    CalcsScenarioDataSetupComponent,
    CalcsFilingGroupStatusComponent,
    Trueup905cCommentsComponent,
    FirTrueupTaxesComponent,
    LocalSysChartAcctMapDeleteComponent,
    LocalSysChartAcctMapComponent,
    FirLocalAcctDescComponent,
    FirLocalSysChartAcctMapComponent,
    Fir8865SchedulePComponent,
    Form8865TextualComponent,
    Fir5471ScheduleG1Component,
    FirRepointComponent,
    F8865SchdK1Component,
    MaxLoanDeleteComponent,
    MaxLoanBalHoComponent,
    TaxLiabilityDashboardComponent,
    SourcingInputAppBasketComponent,
    ConsolGroupEditComponent,
    Form8858TextualinfoComponent,
    Form5471TextinfoComponent,
    Form5471ScheduleGComponent,
    Form5471ScheduleIComponent,
    NonFinancialDirectOwnerComponent,
    NonFinancialTaxOwnerComponent,
    AddSchdmTemplateIdComponent,
    RetainedEarningsComponent,
    AllLocalChartAdjustmentsComponent,
    ReclassLocalChartComponent,
    EpAdjsLocalChartComponent,
    ElimReclassLocalComponent,
    Fir5471ScheduleFComponent,
    Fir5471ScheduleEComponent,
    Fir5471ScheduleJComponent,
    FirSysFormChartAcctMapComponent,
    FirSanctionedCountriesComponent,
    Fir8990ScheduleBComponent,
    FirDividendsPaymentComponent,
    FirMainTrialBalComponent,
    FirReviewBookToEpComponent,
    FirGiltiCalcGridComponent,
    FirGiltiConsolidatedGridComponent,
    FirSubmitterDiagnosticsComponent,
    FirDiagnosticCenterComponent,
    FirConsolidationTbComponent,
    DataProduce5471Component,
    DataProduce8858Component,
    FirEpDrilldownComponent,
    FirAnalyzeCurrentTaxesComponent,
    MaxLoanBalanceComponent,
    FirPost86TaxHistoryComponent,
    FirPtiSummaryReportComponent,
    FirBasketMaintenanceComponent,
    FirCfcsWithQualDefComponent,
    FirCfcsWithRecapAcctComponent,
    FirHoveringDeficitComponent,
    FirGtapsCommonTemplateComponent,
    FirPost86EpHistoryComponent,
    ProjectTaggingComponent,
    ProjectTagComponent
  ],
  exports: [
    SupplementalInfoComponent,
    SourcingDefaultMeComponent,
    SpotratesAllCurrSyncComponent,
    FxAmtSyncComponent,
    BatchSourcingDefaultComponent,
    TestedUnitsSyncComponent,
    FxRatesSyncComponent,
    SourcingProjectTaggingComponent,
    DomesticProjectTaggingComponent,
    GhostUpdateCombinationComponent,
    FgnF5471H1Component,
    FgnOverrides163jComponent,
    SettlementRedirectionComponent,
    FirFormRegenComponent,
    FirGhostOwnershipComponent,
    FirGhostSourcingComponent,
    FirQbuSourcingDeleteRecordComponent,
    Fir163jTaggingComponent,
    Fir163jDefaultSystemTaggingComponent,
    Fir163jResetDefaultTaggingComponent,
    Fir163jSyncTo8990Component,
    Fir5471ScheduleMComponent,
    Fir5471ScheduleIComponent,
    Fir163jsyncComponent,
    Fir5471ScheduleOComponent,
    CfcGroupElectComponent,
    FirEpBumpComponent,
    Fir8858ScheduleMComponent,
    GhostOwnershipInfoDeleteComponent,
    GhostcNonghostDeleteComponent,
    GhostSettlementReclassesDeleteComponent,
    GhostUsdbasisptiNonghostDeleteComponent,
    GhostFtceNonghostDeleteComponent,
    GhostEarnprofitNonghostDeleteComponent,
    BasketMaintenanceDeleteComponent,
    FirAdjustPriorYearDataComponent,
    DcsGhostSettlementComponent,
    Fir8865ScheduleOComponent,
    FirTrueupTaxesComponent,
    Trueup905cCommentsComponent,
    CalcsScenarioDataSetupComponent,
    CalcsFilingGroupStatusComponent,
    LocalSysChartAcctMapDeleteComponent,
    LocalSysChartAcctMapComponent,
    FirLocalAcctDescComponent,
    FirLocalSysChartAcctMapComponent,
    Fir8865SchedulePComponent,
    Form8865TextualComponent,
    Fir5471ScheduleG1Component,
    FirRepointComponent,
    F8865SchdK1Component,
    MaxLoanDeleteComponent,
    MaxLoanBalHoComponent,
    TaxLiabilityDashboardComponent,
    SourcingInputAppBasketComponent,
    ConsolGroupEditComponent,
    Form8858TextualinfoComponent,
    Form5471TextinfoComponent,
    Form5471ScheduleGComponent,
    Form5471ScheduleIComponent,
    NonFinancialDirectOwnerComponent,
    NonFinancialTaxOwnerComponent,
    AddSchdmTemplateIdComponent,
    RetainedEarningsComponent,
    AllLocalChartAdjustmentsComponent,
    ReclassLocalChartComponent,
    EpAdjsLocalChartComponent,
    ElimReclassLocalComponent,
    Fir5471ScheduleFComponent,
    Fir5471ScheduleEComponent,
    Fir5471ScheduleJComponent,
    FirSysFormChartAcctMapComponent,
    FirSanctionedCountriesComponent,
    Fir8990ScheduleBComponent,
    FirDividendsPaymentComponent,
    FirMainTrialBalComponent,
    FirReviewBookToEpComponent,
    FirGiltiCalcGridComponent,
    FirGiltiConsolidatedGridComponent,
    FirSubmitterDiagnosticsComponent,
    FirDiagnosticCenterComponent,
    FirConsolidationTbComponent,
    DataProduce5471Component,
    DataProduce8858Component,
    FirEpDrilldownComponent,
    FirAnalyzeCurrentTaxesComponent,
    MaxLoanBalanceComponent,
    FirPost86TaxHistoryComponent,
    FirPtiSummaryReportComponent,
    FirBasketMaintenanceComponent,
    FirCfcsWithQualDefComponent,
    FirCfcsWithRecapAcctComponent,
    FirHoveringDeficitComponent,
    FirGtapsCommonTemplateComponent,
    FirPost86EpHistoryComponent,
    ProjectTaggingComponent,
    ProjectTagComponent
  ],

  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    AppNgMaterialModule,
    AppNgAppkitModule,
    SharedComponentsModule,
    SharedDirectivesModule,
    GtwSearchableSelectModule,
    SharedPipesModule,
    OverlayModule,
  ],
  schemas: [NO_ERRORS_SCHEMA]
})
export class ForeignModule {}
